import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiProjectGridItem } from '@madeinlune/massaud-types';
import { SnapScrollerDirective } from '@nx-massaud/snap-scroller';
import { SvgIconComponent } from '@nx-massaud/ui/svg-icon';
import { PushPipe } from '@ngrx/component';
import { NgArrayPipesModule } from 'ngx-pipes';
import { TranslocoModule } from '@ngneat/transloco';
import { GridListComponent } from '@nx-massaud/ui/grid';

@Component({
  selector: 'msd-ui-associated-projects',
  standalone: true,
  imports: [
    CommonModule,
    GridListComponent,
    SnapScrollerDirective,
    SvgIconComponent,
    PushPipe,
    NgArrayPipesModule,
    TranslocoModule,
  ],
  template: `
    <ng-container *ngIf="projects && projects.length > 0">
      <div class="associated-header mb-lg">
        <ng-container *transloco="let t">
          <span
            class="block text-uppercase"
            [innerHTML]="t('associated.discover')"
          ></span>
        </ng-container>
        <ng-container *ngIf="snapScroller">
          <div class="b-snap-scroller-navigation">
            <div class="b-next-previous">
              <button
                class="msd-btn icon absolute-unit"
                (click)="snapScroller.previous()"
                [class.active]="snapScroller.canPrevious$ | ngrxPush"
              >
                <msd-ui-svg-icon [icon]="'slideshow-previous'">
                </msd-ui-svg-icon>
              </button>
              <button
                class="msd-btn icon absolute-unit"
                (click)="snapScroller.next()"
                [class.active]="snapScroller.canNext$ | ngrxPush"
              >
                <msd-ui-svg-icon [icon]="'slideshow-next'"></msd-ui-svg-icon>
              </button>
            </div>
          </div>
        </ng-container>
      </div>
      <msd-ui-grid-list
        nxMassaudSnapScroller
        #snapScroller="snapScroller"
        [containerId]="'projects'"
        [enable]="true"
        [data]="projects | sample : 8"
      ></msd-ui-grid-list>
    </ng-container>
  `,
  styleUrls: ['./associated-projects.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AssociatedProjectsComponent {
  @Input()
  projects: UiProjectGridItem[] | undefined;
}
